module.exports = __webpack_public_path__ + "static/media/gal0809-19.467d8637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal0809/gal0809-19.jpg
// module id = 544
// module chunks = 0